setTimeout(() => {
  console.log('apply star ratings')
  $(`.rating-star`).each((i, e) => {
    console.log(i, e);
    var rating = $(e).attr('star-rating');
    $(e).starRating({
      totalStars: 5,
      initialRating: rating,
      starShape: 'rounded',
      starSize: 15,
      emptyColor: 'lightgray',
      activeColor: '#000',
      useGradient: false,
      readOnly: true
    });
    $(e).starRating('setRating', rating, false);
  });

  InsertSubscriptionIds();
}, 1000);

function InsertSubscriptionIds() {
  console.log("Insert subscription Ids");
  var productForms = $('gp-product product-form.product-form form');
  console.log(productForms);
  productForms.each((i, f) => {
    const prodInfo = $(f).parent().parent();
    const prodInfoContext = $(prodInfo).attr('gp-context');
    const prodInfoContext_Obj = JSON.parse(prodInfoContext);

    let SUBInput = $(f).find('input[type="hidden"][name="selling_plan"]');

    //<input type="hidden" name="selling_plan" value="{{ product.selling_plan_groups[0].selling_plans[0].id }}">
    
    // If hidden input doesn't exist, create it
    if (SUBInput.length === 0) {
      SUBInput = $('<input>', {
        type: 'hidden',
        name: 'selling_plan',
        value: prodInfoContext_Obj['variantSelected']['selling_plan_allocations'][0]['selling_plan_id']
      }).appendTo($(f));
      console.log(i, SUBInput, prodInfoContext_Obj);
    }
  });
}


async function getProductPrice(handle) {
    const STOREFRONT_ACCESS_TOKEN = 'a66ad7ca97ca68a7e68a6c19a5327d7f';
    const endpoint = `/api/2023-10/graphql.json`;
    const countryCode = window.Shopify.country;
    const query = `
      query getProductByHandle($handle: String!) @inContext(country: ${countryCode}) {
        product(handle: $handle) {
          title
          variants(first: 1) {
            edges {
              node {
                id
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                sellingPlanAllocations(first: 10) {
                  edges {
                    node {
                      sellingPlan {
                        id
                        name
                        options {
                          name
                          value
                        }
                        priceAdjustments {
                          adjustmentValue {
                            percentage {
                              value
                            }
                            amount {
                              amount
                              currencyCode
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: { handle },
      }),
    });

    const json = await res.json();
    const variant = json?.data?.product?.variants?.edges?.[0]?.node;
    if (!variant) return null;

    return {
      price: variant.price.amount,
      compare_at_price: variant.compareAtPrice?.amount || null,
      currency: variant.price.currencyCode,
    };
  }